import OnlineProgramsModal from './component'
export default OnlineProgramsModal
